const tglConvert = (tgl) => {

    var date = new Date(tgl);
    var getBulan = date.getMonth() + 1; var bulan = '';
    if (getBulan == '1') {bulan = 'Jan'} 
    else if(getBulan == '2') {bulan = 'Feb'}
    else if(getBulan == '3') {bulan = 'Mar'}
    else if(getBulan == '4') {bulan = 'Apr'}
    else if(getBulan == '5') {bulan = 'Mei'}
    else if(getBulan == '6') {bulan = 'Jun'}
    else if(getBulan == '7') {bulan = 'Jul'}
    else if(getBulan == '8') {bulan = 'Agt'}
    else if(getBulan == '9') {bulan = 'Sep'}
    else if(getBulan == '10') {bulan = 'Okt'}
    else if(getBulan == '11') {bulan = 'Nov'}
    else if(getBulan == '12') {bulan = 'Des'}

    var minutes = 1000 * 60;
    var hours = minutes * 60;

    return {
        tgl : date.getDate() + " " + bulan + " " + date.getFullYear(),
        jam : date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()
    }
}

const check_gelar_depan = (data) => {
    if (data == undefined || data == null || data == '') {
        return ''
    } else {
        return data+'. '
    }
}
const check_gelar_belakang = (data1) => {
    if (data1 == undefined || data1 == null || data1 == '') {
        return ''
    } else {
        return ', '+data1
    }
}


const getStatus = (data) => {
    if (data == 0) {
        return {
            color : '#f3b101',
            icon : 'hourglass_empty'
        }
    } else if (data == 1) {
        return {
            color : '#6fc500',
            icon : 'done'
        }
    } else {
        return {
            color : '#c50000',
            icon : 'close'
        }
    }
}


const getIdikatorPemeriksa = (data) => {
    if (data > 0) {
        return {
            color : 'red-7',
            icon : 'hourglass_empty',
            reset : true,
        }
    }

    else{
        return {
            color : 'primary',
            icon : 'hourglass_empty',
            reset : false,
        }
    }
}

const checkClick =  (data)=>{
    if (data == 2) {
        return true
    } else {
        return false
    }
}

const namaLengkap = (gelardepan, nama, gelarBelakang) =>{
    return check_gelar_depan(gelardepan)+""+nama+""+check_gelar_belakang(gelarBelakang)
}


// =================== PAGINASI =========================

const btn_prev = (page_first) =>{

}


const btn_next = (page_first, page_last) => {

}


const checkDisabled = (diterima, dikembalikan) =>{
    if (diterima > 0 && dikembalikan <= 0 ){
        return true
    }
    else if (diterima > 0 && dikembalikan > 0){
        return false
    }

    else if (diterima == 0 && dikembalikan == 0){
        return false
    }

    else if (diterima <= 0 && dikembalikan > 0){
        return false
    }

} 



const approveSweetAlert = (textq)=>{
    return new Promise ((resolve)=>{
        swal({
            title: "Apakah anda yakin",
            text: textq,
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then((willDelete) => {
            if (willDelete) {
                resolve('')
            } else {
              return false
            }
          });
    })
}



const notifSweetAlert = (status, keterangan, icon)=>{
        swal(status, keterangan, icon);
}



module.exports = {
    tglConvert : tglConvert,
    check_gelar_depan : check_gelar_depan,
    check_gelar_belakang : check_gelar_belakang,
    namaLengkap : namaLengkap,
    btn_prev : btn_prev,
    btn_next : btn_next,
    getStatus: getStatus,
    checkClick : checkClick,
    getIdikatorPemeriksa : getIdikatorPemeriksa,
    checkDisabled : checkDisabled,
    approveSweetAlert : approveSweetAlert,
    notifSweetAlert : notifSweetAlert,
}